import Vue from "vue";

const modulo_albaran_venta = {
    strict: false,

    state: {
        albaranes: [],
        current: 0,
        page: 1,
        // state que se usa para almacenar las ordenes seleccionadas para crear una factura desde "facturacion"
        albaranesData: []
    },

    getters: {
        getalbaranVenta: (state) => state.albaranes,
        getAlbaranVentaData: (state) => state.albaranesData,
    },

    mutations: {
        get_albaran_venta: (state, albaranes) => {
            state.albaranes = albaranes;
            state.page = 2;
        },
        update_albaran_venta: (state, albaranes) => {
            state.albaranes = state.albaranes.concat(albaranes.data);
            state.page = albaranes.current_page + 1;
        },
        add_search: (state, albaranes) => {
            state.albaranes = state.albaranes.concat(albaranes);
        },

        // mutaciones del estado ordenesData
        setAlbaranVentaData(state, data) {
            state.albaranesData = data;
        },
        clearAlbaranVentaData(state) {
            state.albaranesData = [];
        }
    },

    actions: {
        getAlbaranVenta: (context, vm) => {
            axios.get("api/albaran/venta", {
                page: 1,
                rowsPerPage: 15
            }).then(
                (res) => {
                    console.log('albaranes', res.data.success.data);
                    context.commit("get_albaran_venta", res.data.success.data);
                },
                (res) => {}
            );
        },
        getAlbaranVentaWithId: (context, vm) => {
            axios.get(`api/albaran/venta`, {
                page: 1,
                rowsPerPage: 15
            }).then(
                (res) => {
                    context.commit("get_albaran_venta", res.data.success.data);
                },
                (res) => {}
            );
        },
        getAlbaranVentaNext: (context, vm) => {
            axios
                .get(
                    `api/albaran/venta`, {
                        page: context.state.page ?? 1,
                        rowsPerPage: 15
                    }
                )
                .then(
                    (res) => {
                        context.commit("update_albaran_venta", res.data.success);
                    },
                    (res) => {}
                );
        },
        searchAlbaranVenta: (context, vm) => {
            axios
                .get(`api/albaran/venta?rowsPerPage=15&page=1${vm ? `&search=${vm}` : ""}`)
                .then(
                    (res) => {
                        context.commit("update_albaran_venta", res.data.success);
                    },
                    (res) => {}
                );
        },

        // Actions para establecer y remover ordenesData
        setAlbaranVentaData({ commit }, data) {
            commit('setAlbaranVentaData', data);
        },
        clearAlbaraVentaData({ commit }) {
            commit('clearAlbaranVentaData');
        }
    },
};

export default modulo_albaran_venta;
